import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-stepper-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper-header.component.html',
  styleUrls: ['./stepper-header.component.scss'],
})
export class StepperHeaderComponent {
  @Input() title = '';
  @Input() steps: { label: string }[] = [];
  @Input() step: number = 0;
  @Input() submittedDate: Date | null = null;
  @Input() reporter: string | null = null;
  @Input() status: string = 'pending';
  @Input() classification: string | null = null;
}
